import { Button } from '@xo-union/tk-component-buttons';
import Spinner from '@xo-union/tk-component-spinner';
import React from 'react';

import styles from './tripleAction.scss';

interface Props {
  className?: string;
  primaryText: string;
  primaryOnClick: Function;
  primaryDisabled?: boolean;
  secondaryText?: string;
  secondaryOnClick?: Function;
  secondaryDisabled?: boolean;
  tertiaryText?: string;
  tertiaryOnClick?: Function;
  tertiaryDisabled?: boolean;
  showSpinner?: boolean;
  mode?: 'sideBySide' | 'stack' | 'stackFocus';
  buttonsSize?: 'sm' | 'md' | 'lg';
}

export const TripleAction: React.FC<Props> = ({
  className = '',
  primaryText,
  primaryOnClick,
  primaryDisabled,
  secondaryText,
  secondaryOnClick,
  secondaryDisabled,
  tertiaryText,
  tertiaryOnClick,
  tertiaryDisabled,
  showSpinner,
  mode = 'sideBySide',
  buttonsSize = 'md',
}) => {
  return (
    <div className={`${styles.container} ${className} ${styles[mode]}`}>
      {showSpinner && (
        <div className={styles.spinner}>
          <Spinner data-testid="triple-action-spinner" />
        </div>
      )}
      <div className={showSpinner ? styles.hidden : ''}>
        <div className={styles.buttonContainer}>
          {secondaryText && (
            <Button
              data-testid="secondary-action"
              size={buttonsSize}
              color="secondary"
              block
              disabled={secondaryDisabled}
              onClick={secondaryOnClick}
            >
              {secondaryText}
            </Button>
          )}
          <Button
            data-testid="primary-action"
            size={buttonsSize}
            color="primary"
            block
            disabled={primaryDisabled}
            onClick={primaryOnClick}
          >
            {primaryText}
          </Button>
        </div>
        {tertiaryText && (
          <div className={styles.bottomButtonContainer}>
            <Button
              data-testid="tertiary-action"
              size={buttonsSize}
              color="tertiary"
              block
              disabled={tertiaryDisabled}
              onClick={tertiaryOnClick}
            >
              {tertiaryText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
